export default "__VITE_ASSET__2Ddpcnkx__"